
const HtmlHeader = ({ text, type, withMargin }) => {

  switch (type) {
    case "h1":
      return (
        <h1 className={withMargin && "header-margin header-top-margin"}>{text}</h1>
      );
    case "h2":
      return (
        <h2 className={withMargin && "header-margin"}>{text}</h2>
      );
    case "h3":
      return (
        <h3 className={withMargin && "header-margin"}>{text}</h3>
      );
    case "h4":
      return (
        <h4 className={withMargin && "header-margin"}>{text}</h4>
      );
    default:
      return (
        <h3 className={withMargin && "header-margin"}>{text}</h3>
      );
  }
}

export default HtmlHeader;